// extracted by mini-css-extract-plugin
module.exports = {"singleSlider":"ReI2x","textsize":"OEljY","description":"EKlvA"};